import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=5355a9c2"
import script from "./TextField.vue?vue&type=script&lang=ts"
export * from "./TextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports